import { createRouter, createWebHistory } from 'vue-router'

import { authRoutes } from './routes/auth.routes'
import { mainRoutes } from './routes/main.routes'

const router = createRouter({
  history: createWebHistory(),
  routes: [...authRoutes, ...mainRoutes]
})

export default router
